import { useEffect, useState } from "react";

export default function useModelInfoRows(basicInfo, isLoading) {
    const [modelInfoRows, setModelInfoRows] = useState([]);

    useEffect(() => {
        if (!!basicInfo && !isLoading) {
            const newRows = [];
            newRows.push({ attribute: "Serial Number", value: basicInfo.serialNumber });
            newRows.push({ attribute: "Model Number", value: basicInfo.modelNum });
            if (!!basicInfo.registrationCountryCode) {
                newRows.push({ attribute: "Registration Country Code", value: basicInfo.registrationCountryCode });
            }
            if (!!basicInfo.standardWarrantyDateStart || !!basicInfo.standardWarrantyDateExpire) {
                newRows.push({ attribute: "Warranty Period", value: `${basicInfo.standardWarrantyDateStart || ''} - ${basicInfo.standardWarrantyDateExpire || ''}` });
            }
            if (!!basicInfo.extendedWarrantyType) {
                newRows.push({ attribute: "Registration Country Code", value: basicInfo.registrationCountryCode });
            }
            if (!!basicInfo.extendedWarrantyDateExpire) {
                newRows.push({ attribute: "MPP Expire", value: `${basicInfo.extendedWarrantyDateStart || ''} - ${basicInfo.extendedWarrantyDateExpire || ''}` });
            }
            if (!!basicInfo.extendedAttributes.horsepower?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.horsepower.description, value: basicInfo.extendedAttributes.horsepower.value });
            }
            if (!!basicInfo.extendedAttributes.colorScheme?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.colorScheme.description, value: basicInfo.extendedAttributes.colorScheme.value });
            }
            if (!!basicInfo.extendedAttributes.cylinderConfiguration?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.cylinderConfiguration.description, value: basicInfo.extendedAttributes.cylinderConfiguration.value });
            }
            if (!!basicInfo.extendedAttributes.cylinderCount?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.cylinderCount.description, value: basicInfo.extendedAttributes.cylinderCount.value });
            }
            if (!!basicInfo.extendedAttributes.displacementLiter?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.displacementLiter.description, value: basicInfo.extendedAttributes.displacementLiter.value });
            }
            if (!!basicInfo.extendedAttributes.airInduction?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.airInduction.description, value: basicInfo.extendedAttributes.airInduction.value });
            }
            if (!!basicInfo.extendedAttributes.certification?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.certification.description, value: basicInfo.extendedAttributes.certification.value });
            }
            if (!!basicInfo.extendedAttributes.driveshaftLength?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.driveshaftLength.description, value: basicInfo.extendedAttributes.driveshaftLength.value });
            }
            if (!!basicInfo.extendedAttributes.fuelInduction?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.fuelInduction.description, value: basicInfo.extendedAttributes.fuelInduction.value });
            }
            if (!!basicInfo.extendedAttributes.fuelTank?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.fuelTank.description, value: basicInfo.extendedAttributes.fuelTank.value });
            }
            if (!!basicInfo.extendedAttributes.gearRatio?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.gearRatio.description, value: basicInfo.extendedAttributes.gearRatio.value });
            }
            if (!!basicInfo.extendedAttributes.gearcase?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.gearcase.description, value: basicInfo.extendedAttributes.gearcase.value });
            }
            if (!!basicInfo.extendedAttributes.midsection?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.midsection.description, value: basicInfo.extendedAttributes.midsection.value });
            }
            if (!!basicInfo.extendedAttributes.propellerRotation?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.propellerRotation.description, value: basicInfo.extendedAttributes.propellerRotation.value });
            }
            if (!!basicInfo.extendedAttributes.series?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.series.description, value: basicInfo.extendedAttributes.series.value });
            }
            if (!!basicInfo.extendedAttributes.smartCraftCompatible?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.smartCraftCompatible.description.replace('Smart Craft', 'SmartCraft'), value: basicInfo.extendedAttributes.smartCraftCompatible.value });
            }
            if (!!basicInfo.extendedAttributes.startingType?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.startingType.description, value: basicInfo.extendedAttributes.startingType.value });
            }
            if (!!basicInfo.extendedAttributes.steering?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.steering.description, value: basicInfo.extendedAttributes.steering.value });
            }
            if (!!basicInfo.extendedAttributes.technology?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.technology.description, value: basicInfo.extendedAttributes.technology.value });
            }
            if (!!basicInfo.extendedAttributes.throttleShiftControl?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.throttleShiftControl.description, value: basicInfo.extendedAttributes.throttleShiftControl.value });
            }
            if (!!basicInfo.extendedAttributes.trimTilt?.value) {
                newRows.push({ attribute: basicInfo.extendedAttributes.trimTilt.description, value: basicInfo.extendedAttributes.trimTilt.value });
            }
            setModelInfoRows(newRows);
        }
    }, [basicInfo, isLoading]);

    return modelInfoRows;
}